import Spinner from "~/components/shared/Spinner";
import Loadable from "react-loadable";

type LoadingProps = {
  error?: any;
  pastDelay?: boolean;
};

const LoadingMessage = (props: LoadingProps) => {
  if (props.error) {
    return <div>Error loading charts. Please reload</div>;
  } else if (props.pastDelay) {
    return (
      <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center">
        <Spinner />
      </div>
    );
  }
  return null;
};

const LoadableChart = Loadable({
  loader: () => import("./chart"),
  loading: LoadingMessage,
});

type Props = {
  height: number;
  width?: number;
  chartOptions: {
    [key: string]: any;
  };
  canvasId?: string;
};

export default function Chart(props: Props) {
  return (
    <div className="relative" style={{ height: props.height, width: props.width }}>
      <LoadableChart chartOptions={props.chartOptions} canvasId={props.canvasId} />
    </div>
  );
}
